<footer class="bg-black text-white pt-5 pb-3">
  <div class="container-fluid px-md-5">
    <div class="row g-4 mb-4">

      <div class="col-6 col-md-3 col-lg-2">
        <h5 class="fw-bold mb-3 border-bottom border-success border-2 d-inline-block pb-1">Menu rapide</h5>
        <ul class="list-unstyled d-flex flex-column gap-2">
          <li><a href="#a-propos" class="footer-link" style="cursor: pointer;">A propos de nous</a></li>
          <li><a href="#offres" class="footer-link" style="cursor: pointer;">Offre de location</a></li>
          <li><a href="#pourquoi" class="footer-link" style="cursor: pointer;">Pourquoi nous choisir ?</a></li>
          <li><a (click)="devenir()" class="footer-link" style="cursor: pointer;">Devenir partenaire</a></li>
        </ul>
      </div>

      <div class="col-6 col-md-3 col-lg-2">
        <h5 class="fw-bold mb-3 border-bottom border-success border-2 d-inline-block pb-1">Compte</h5>
        <ul class="list-unstyled d-flex flex-column gap-2">
          <li><a (click)="openModal_inscription()" class="footer-link" style="cursor: pointer;">S’inscrire</a></li>
          <li><a (click)="openModal_connexion()" class="footer-link" style="cursor: pointer;">Se connecter</a></li>
        </ul>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <h5 class="fw-bold mb-3 border-bottom border-success border-2 d-inline-block pb-1">Contact</h5>
        <ul class="list-unstyled d-flex flex-column gap-3">
          <li class="d-flex align-items-start gap-3">
            <i class="bi bi-geo-alt-fill text-success"></i>
            <span class="text-light">SICAP SACRE COEUR 3, MERMOZ, Dakar, Sénégal</span>
          </li>
          <li class="d-flex align-items-center gap-3">
            <i class="bi bi-telephone-fill text-success"></i>
            <span class="text-light">+221 33 864 28 29</span>
          </li>
          <li class="d-flex align-items-center gap-3">
            <i class="bi bi-telephone-fill text-success"></i>
            <span class="text-light">+221 78 540 92 92</span>
          </li>
          <li class="mt-2">
            <div class="d-flex gap-3 social-icons">
              <a class="text-light fs-5" style="cursor: pointer;"><i class="bi bi-twitter-x" ></i></a>
              <a class="text-light fs-5" style="cursor: pointer;"><i class="bi bi-facebook"></i></a>
              <a class="text-light fs-5" style="cursor: pointer;"><i class="bi bi-instagram"></i></a>
              <a class="text-light fs-5" style="cursor: pointer;"><i class="bi bi-linkedin"></i></a>
            </div>
          </li>
        </ul>
      </div>

      <div class="col-12 col-lg-4">
        <div class="ratio ratio-21x9 rounded shadow-sm border border-secondary border-opacity-25 overflow-hidden">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1226.0143010932566!2d-17.4709356!3d14.7165349!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec173001f3562c1%3A0x5f282428b09d18ad!2sR%C3%A9sidence%20Maryse!5e1!3m2!1sfr!2ssn!4v1781877470764!5m2!1sfr!2ssn" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            style="border:0;" allowfullscreen="" loading="lazy">
          </iframe>
        </div>
      </div>

    </div>

    <div class="border-top border-secondary border-opacity-25 pt-4 mt-4 text-center">
      <p class="small text-secondary mb-0">
        © {{ currentYear }} <span class="text-white fw-bold">Jant Tech</span>. Tous droits réservés.
      </p>
    </div>
  </div>
</footer>
